import {Fetch} from "@/apis/Fetch";


import {PaymentAPI} from "@/apis/PaymentAPI";
import PaymentMethodForm from "../PaymentMethodForm";
import {FalStripe} from "@/shared/falconStripe";
import PaymentMethodsModal from "../../modals/PaymentMethodsModal";
import {getRedirectToAfterUpgrade, removeRedirectToAfterUpgrade} from "@/shared/utils";
import Layout from "@/shared/components/Layout";
import Loading from "@/shared/components/Loading";
import {mapGetters} from "vuex";
import {FinModelsAPI} from "@/apis/FinModelsAPI";

var trackToGoogle = function () {
    return;
    typeof gtag !== "undefined"? gtag('event', 'conversion', {
        'send_to': 'AW-408551170/6nAaCJmD0fsBEIL-58IB',
        'transaction_id': '',
        'event_callback': function () {

        }
    }): null;
};

export default {
    name: "Account.vue",
    components: {Layout, PaymentMethodForm, Loading},
    data() {
        return {
            loading: false,
            initLoading: false,
            formData: {},
            cardNumber: null,
            price: {},
            template: {},
            paymentMethod: {},
            invalidDiscountCode: false,
            isDiscountLoading: false,
            discountCode: null,
            discountValue: {}
        }
    },
    async mounted() {
        this.initLoading = true;
        this.price = await PaymentAPI.getPriceDetails(this.$route.params.priceId)
        this.paymentMethod = await PaymentAPI.getPaymentMethods();
        if(this.$route.query.templateId){
            this.template = await FinModelsAPI.getTemplate(this.$route.query.templateId)
        }
        this.initLoading = false;
    },
    methods: {
        async checkOut() {
            SFAnalytics.track('Checkout Viewed', { })
            let stripe = FalStripe(), resp;
            this.loading = true;

            if (!this.paymentMethod.has_payment) {
                resp = await this.$refs.paymentMethodForm.createPaymentMethod();
                if (!resp) {
                    this.loading = false;
                    return;
                }

            } else {
                resp = {
                    id: this.paymentMethod.card.id,
                }
            }

            let paymentDetails = {
                price_id: this.price.id,
            };

            if (this.discountValue && this.discountValue.valid) {
                paymentDetails['discount_code'] = this.discountCode;
            }

            if (this.paymentMethod.has_payment || resp.httpStatus === 200) {
                let endpoint = "api/payment/subscription/";
                if(this.price.one_time) {
                    endpoint = "api/payment/subscription/one_time/";
                }
                else if(this.price.is_fin_model) {
                    endpoint = "api/payment/subscription/fin_model/";
                    paymentDetails = {
                        ...paymentDetails,
                        template_id: this.template.id,
                    }
                }
                let sub_resp = await Fetch('POST', endpoint, paymentDetails);
                if (!sub_resp.success) {
                    this.$toasted.show(sub_resp.message, {
                        theme: "bubble",
                        position: "top-center",
                        duration: 4000,
                        className: 'falcon-toasted',
                    });
                    this.loading = false;
                } else {
                    let paymentMethodId = resp.id;
                    if (sub_resp.status === "requires_action") {
                        try {
                            let result = await stripe.confirmCardPayment(sub_resp.client_secret, {
                                payment_method: paymentMethodId,
                            });
                            if (result.error) {
                                // Start code flow to handle updating the payment details.
                                // Display error message in your UI.
                                // The card was declined (i.e. insufficient funds, card has expired, etc).
                                this.$toasted.show(result.error.message, {
                                    theme: "bubble",
                                    position: "top-center",
                                    duration: 12000,
                                    className: 'falcon-toasted',
                                });
                                this.loading = false;
                            } else {
                                if (result.paymentIntent.status === 'succeeded') {
                                    // Same as USER_UPGRADED
                                    SFAnalytics.track('User Plan Updated', { })
                                    trackToGoogle();
                                    let redirectTo = getRedirectToAfterUpgrade()
                                    if(redirectTo){
                                        removeRedirectToAfterUpgrade();
                                        this.$router.push(redirectTo);
                                    }
                                    else {
                                        this.$router.push({
                                            'name': 'onboarding',
                                            'query': {
                                                'type': this.isStartup ? 'stp' : 'ent',
                                                'upgraded': '1'
                                            }
                                        });
                                    }

                                }
                                this.loading = false;
                            }
                        } catch (e) {

                        }
                    } else if (sub_resp.status === "requires_payment_method") {
                        this.$toasted.show("Please check your card information", {
                            theme: "bubble",
                            position: "top-center",
                            duration: 12000,
                            className: 'falcon-toasted',
                        });
                        this.loading = false;
                    } else {
                        trackToGoogle();
                        SFAnalytics.track('User Plan Updated', { })
                        let redirectTo = getRedirectToAfterUpgrade()
                        if(this.$route.query.templateId){
                            this.$router.push({
                                'name': 'fin-models',
                            });
                        }
                        else if (redirectTo) {
                            removeRedirectToAfterUpgrade();
                            this.$router.push(redirectTo);
                        } else {
                            this.$router.push({
                                'name': 'onboarding',
                                'query': {
                                    'type': this.isStartup ? 'stp' : 'ent',
                                    'upgraded': '1'
                                }
                            });
                        }
                        this.loading = false;
                    }
                }
            } else {
                this.$toasted.show(resp.message, {
                    theme: "bubble",
                    position: "top-center",
                    duration: 12000,
                    className: 'falcon-toasted',
                });
                this.loading = false;
            }

        },
        async applyDiscountCode() {
            if (!this.discountCode) {
                this.invalidDiscountCode = true;
                return;
            }
            this.invalidDiscountCode = false;
            this.isDiscountLoading = true;
            let resp = await PaymentAPI.applyCoupon(this.discountCode, this.price.product_details.id);
            if (resp.httpStatus === 200 && resp.coupon.valid) {
                this.discountValue = resp.coupon;
            } else {
                this.invalidDiscountCode = true;
            }

            this.isDiscountLoading = false;
        },
        showPaymentMethodModal() {
            this.$buefy.modal.open({
                parent: this,
                component: PaymentMethodsModal,
                customClass: " small-modal",
                props: {},
                close: () => {
                    console.log('onClose 333')
                },
                events: {
                    close: async () => {
                        this.loading = true;
                        this.paymentMethod = await PaymentAPI.getPaymentMethods();
                        this.loading = false;
                    }
                }
            })
        },
    },
    computed: {
        ...mapGetters(['userInfo', 'isStartup', 'isInvestor', 'hasProfile']),
        compute_price() {

            let price = this.price.unit_amount, discounted_price = price;
            if (this.discountValue && this.discountValue.valid) {

                if (this.discountValue.amount_off) {
                    discounted_price -= this.discountValue.amount_off;
                } else if (this.discountValue.percent_off) {
                    discounted_price = price - price * this.discountValue.percent_off;
                }

                if (discounted_price <= 0) {
                    discounted_price = 0;
                }
            }
            return {
                price,
                discounted_price,
                hasDiscount: price !== discounted_price
            };
        }
    },
    beforeDestroy() {
        // SFAnalytics.track('Checkout Abandoned', { })
    }
}
